import { AnchorHTMLAttributes, Children, cloneElement, ReactElement } from 'react';

import { Link } from '@natu/next-link';
import { cn } from '@natu/utils/cn';
import { PredefinedGAEvents } from '@natu/utils/events';

import { ButtonWithEvent } from '../Button/ButtonWithEvent';

export interface ConditionalLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  srLabel?: string;
  event?: PredefinedGAEvents;
}

export const ConditionalLink = ({
  href,
  children,
  className,
  srLabel,
  event,
  ...rest
}: ConditionalLinkProps) => {
  if (href && event) {
    return (
      <ButtonWithEvent
        className={cn('inline-block', className)}
        event={event}
        variant={null}
        size="link"
        asChild
      >
        <Link href={href} {...rest}>
          {children}
          {srLabel && <span className="sr-only">{srLabel}</span>}
        </Link>
      </ButtonWithEvent>
    );
  }

  if (href) {
    return (
      <Link href={href} className={cn('inline-block', className)} {...rest}>
        {children}
        {srLabel && <span className="sr-only">{srLabel}</span>}
      </Link>
    );
  }

  const child = Children.only(children);

  return cloneElement(child as ReactElement, {
    // @ts-ignore
    className,
    ...rest,
  });
};
